import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

function Compliance() {
  return (
    <Card>
      <Text type="secondary">This is the Compliance Checker page. Content coming soon!</Text>
    </Card>
  );
}

export default Compliance;
